var grupoBoticarioFonts = [{
  fontFamily: 'IBM Plex Sans',
  fontStyle: 'normal',
  fontWeight: '300',
  src: 'url(https://fonts.gstatic.com/s/ibmplexsans/v13/zYX9KVElMYYaJe8bpLHnCwDKjXr8AIFsdP3pBms.woff2)'
}, {
  fontFamily: 'IBM Plex Sans',
  fontStyle: 'normal',
  fontWeight: '400',
  src: 'url(https://fonts.gstatic.com/s/ibmplexsans/v13/zYXgKVElMYYaJe8bpLHnCwDKhdHeFaxOedc.woff2)'
}, {
  fontFamily: 'IBM Plex Sans',
  fontStyle: 'normal',
  fontWeight: '500',
  src: 'url(https://fonts.gstatic.com/s/ibmplexsans/v13/zYX9KVElMYYaJe8bpLHnCwDKjSL9AIFsdP3pBms.woff2)'
}, {
  fontFamily: 'IBM Plex Sans',
  fontStyle: 'normal',
  fontWeight: '600',
  src: 'url(https://fonts.gstatic.com/s/ibmplexsans/v13/zYX9KVElMYYaJe8bpLHnCwDKjQ76AIFsdP3pBms.woff2)'
}, {
  fontFamily: 'IBM Plex Sans',
  fontStyle: 'normal',
  fontWeight: '700',
  src: 'url(https://fonts.gstatic.com/s/ibmplexsans/v13/zYX9KVElMYYaJe8bpLHnCwDKjWr7AIFsdP3pBms.woff2)'
}];
var eudoraFonts = [{
  fontFamily: 'Sofia Pro',
  fontStyle: 'normal',
  fontWeight: '300',
  src: 'url(https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.366/images/store/46/fonts/SofiaPro-Light.woff2)'
}, {
  fontFamily: 'Sofia Pro',
  fontStyle: 'normal',
  fontWeight: '400',
  src: 'url(https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.366/images/store/46/fonts/SofiaPro-Regular.woff2)'
}, {
  fontFamily: 'Sofia Pro',
  fontStyle: 'normal',
  fontWeight: '700',
  src: 'url(https://res.cloudinary.com/beleza-na-web/raw/upload/v1/blz/assets-store/0.0.366/images/store/46/fonts/SofiaPro-SemiBold.woff2)'
}];
export var fonts = [...grupoBoticarioFonts, ...eudoraFonts];
//# sourceMappingURL=importFonts.js.map